import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Route, withRouter } from 'react-router';
import { Container, Header, Form, Button, Grid, Dimmer, Loader, Image, Segment, Modal } from 'semantic-ui-react';
import { Formik, Field, Form as FormikForm } from 'formik';
import { FormikDateComponent, FormikInputComponent } from '../../../utilities/formUtils';
import ReportOptions from './reportOptions'
import { reconciliationSchema, reportSchema } from '../data/model';
import TransType from './transType';
import LocationSearch from './locationSelect'
import { Link } from 'react-router-dom';
import { fetchDownloadData, fetchDownloadDataWcWi, fetchDownloadDmsToRlbPost, fetchDownloadReconciliation, fetchDownloadReports } from '../data/actions';
import OutletSearch from './outletSelect';
import UploadXlsxForm from './uploadXlsx';
import { getdownloadReportdata, getIsDownloadDataFetched } from '../data/selectors';
import moment from 'moment';
import { fetchSegmap } from '../../segmap/data/actions';
import { getIsSegmapFetched } from '../../segmap/data/selectors'
import DateTypeOptions from './dateTypeSelect';
import TransTypeToRlbOptions from './transTypeRlbSelect';


const ReportsDownloadForm = (props) => {
    const downloadDataFetched = useSelector(state => getIsDownloadDataFetched(state, props))
    const initialData = useSelector(state => getdownloadReportdata(state, props))
    const segmapFetched = useSelector(state => getIsSegmapFetched(state, props))
    const dispatch = useDispatch()
    const account = localStorage.getItem('acc');
    const [displayStatus, setDisplayStatus] = useState(false);
    const [xlResponse, setXlResponse] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [dateModalOpen, setDateModalOpen] = useState(false)
    const [attachedFile, setAttachedFile] = useState(false)

    const [reportOpt, setReportOpt] = useState(initialData ? initialData.report_name : "")
    const date = new Date()
    const todayDate = moment(date).format("YYYY-MM-DD")

    const downloadData = (values, resetForm) => {
        if (values.report_name === 'DMS To RLB posting log') {
            delete values.Trans_Type
            delete values.report_name
            delete values.Location_CD
            delete values.MUL_DEALER_CD
            let obj={}
            obj.fromDate= values.from_date
            obj.toDate= values.to_date
            obj.transtype= values.transtype
            obj.datetype= values.datetype
            dispatch(fetchDownloadDmsToRlbPost(obj))
            setTimeout(() => {
                resetForm()
            }, 2000)

        }
        else if (values.report_name === 'exception_report_wc_wi') {
            delete values.Trans_Type
            delete values.Location_CD
            delete values.MUL_DEALER_CD
            delete values.transtype
            delete values.datetype
            dispatch(fetchDownloadDataWcWi(values))
            setTimeout(() => {
                resetForm()
            }, 2000)

        }
        else if (values.report_name === 'Reconciliation') {
            if (attachedFile) {
                delete values.report_name
                delete values.transtype
                delete values.datetype
                values.account = account
                dispatch(fetchDownloadReconciliation(values, xlResponse))
                setTimeout(() => {
                    resetForm()
                }, 2000)
            }

        }
        else {
            delete values.Trans_Type
            delete values.Location_CD
            delete values.MUL_DEALER_CD
            delete values.transtype
            delete values.datetype
            dispatch(fetchDownloadReports(values))
            setTimeout(() => {
                resetForm()
            }, 2000)
        }
    }

    useEffect(() => {
        if (!segmapFetched) {
            dispatch(fetchSegmap());
        }
    }, []);

    useEffect(() => {
        if (fromDate && toDate) {
            if (fromDate && toDate) {
                let check = moment(fromDate).isAfter(toDate)
                if (check === true) {
                    setDateModalOpen(true)
                }
            }
        }
    }, [fromDate, toDate])

    return (
        <div>
            {downloadDataFetched === 'pending' &&
                <Dimmer active>
                    <Loader indeterminate>Preparing Files</Loader>
                </Dimmer>
            }
            <Grid columns={3} divided>
                <Grid.Row>
                    <Grid.Column style={{ margin: 'auto' }}>
                        <Header style={{ textAlign: 'center', padding: '25px 0' }} as='h1'>Download Reports</Header>
                        <Formik id="downloadDataForm" size="large" width={5}
                            initialValues={initialData}
                            validationSchema={reportOpt === "Reconciliation" ? reconciliationSchema : reportSchema}
                            onSubmit={(values, { resetForm }) => downloadData(values, resetForm)}
                            render={({ handleSubmit, onChange, values, handleChange, setFieldValue }) => (
                                <Form as={FormikForm} size="small" className="CustomeForm" width={5} onSubmit={handleSubmit}>

                                    <ReportOptions name="report_name" placeholder="Report Option" setFieldValue={setFieldValue} width={5} isTxn={false} label="Report Option" setOnSelect={setReportOpt} isSelection={true} />


                                    {
                                        reportOpt === "DMS To RLB posting log" ?
                                            <>
                                                <DateTypeOptions name="datetype" setFieldValue={setFieldValue} width={5} isTxn={false} label="Select DateType" isSelection={true} />
                                                <TransTypeToRlbOptions name="transtype" setFieldValue={setFieldValue} width={5} isTxn={false} label="Select Trans Type" isSelection={true} />
                                            </> : null
                                    }
                                    {
                                        reportOpt === "Reconciliation" ?
                                            <>
                                                <TransType name="Trans_Type" placeholder="Trans Type" width={5} isTxn={false} label="Select Trans Type" isSelection={true} />
                                            </> : null

                                    }
                                    {
                                        (reportOpt === "Reconciliation" || reportOpt === "DMS To RLB posting log") ?
                                            <Form.Group widths={2}>
                                                <Field label="From Date" name="from_date" setFieldValueM={todayDate}  setDate={setFromDate} component={FormikDateComponent} placeholder="dd-mm-yyyy"></Field>
                                                <Field label="To Date" name="to_date" setFieldValueM={todayDate}  setDate={setToDate} component={FormikDateComponent} placeholder="dd-mm-yyyy"></Field>
                                            </Form.Group>
                                            :
                                            <>
                                                <Field label="From Date" name="from_date" setFieldValueM={todayDate} setDate={setFromDate} component={FormikDateComponent} placeholder="dd-mm-yyyy"></Field>
                                                <Field label="To Date" name="to_date" setFieldValueM={todayDate} setDate={setToDate} component={FormikDateComponent} placeholder="dd-mm-yyyy"></Field>
                                            </>
                                    }
                                    {
                                        reportOpt === "Reconciliation" ?
                                            <Form.Group widths={2}>
                                                <LocationSearch name='Location_CD' label='Location' placeholder='Search Location' isTxn={false} isLabel={false} isSelection={true} />
                                                <OutletSearch name='MUL_DEALER_CD' label='Outlet' placeholder='Search Outlet' isTxn={false} isLabel={false} isSelection={true} />
                                            </Form.Group> : null

                                    }

                                    {
                                        reportOpt === "Reconciliation" ?
                                            <>
                                                <Button floated='left' type="button" size="medium" color='green' className="CustomeBTN" onClick={() => { setDisplayStatus(true) }}> Attach File</Button>
                                                <Button floated='right' type="submit" size="medium" color='blue' className="CustomeBTN"> Download Report</Button>
                                            </> :
                                            <div style={{ textAlign: 'center' }}>

                                                <Button type="submit" size="medium" color='blue' className="CustomeBTN"> Download Report</Button>
                                            </div>

                                    }

                                </Form>
                            )}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Modal size='fullscreen' open={displayStatus} onClose={() => setDisplayStatus(false)} >
                <Modal.Content>
                    <UploadXlsxForm setDisplayStatus={setDisplayStatus}
                        setXlResponse={setXlResponse}
                        setAttachedFile={setAttachedFile}
                    />
                </Modal.Content>
            </Modal>
            <Modal open={dateModalOpen} size="mini">
                <Modal.Header>Error</Modal.Header>
                <Modal.Content>
                    <p>To Date Should be Greater than From Date</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button type="button" negative icon='thumbs down outline' content='Okay' labelPosition='right' onClick={() => setDateModalOpen(false)} />
                </Modal.Actions>
            </Modal>
        </div>
    )
};

export default ReportsDownloadForm;